import React__default, { useState } from 'react';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import DefaultIcon from '../DefaultIcon/index.js';

var SingleSimpleAccordion = function (_a) {
    var _b = _a.testId, testId = _b === void 0 ? "SingleSimpleAccordion" : _b, titleComponent = _a.titleComponent, children = _a.children, _c = _a.KIcon, KIcon = _c === void 0 ? DefaultIcon : _c;
    var _d = useState(false), isExpanded = _d[0], setIsExpanded = _d[1];
    return (React__default.createElement(Accordion, { "data-testid": testId, disableGutters: true, expanded: isExpanded, onChange: function () { return setIsExpanded(function (prev) { return !prev; }); }, className: "SingleSimpleAccordion", sx: {
            boxShadow: "none",
            padding: 0,
            margin: "none",
            "&::before": {
                display: "none"
            },
            "& .MuiAccordionSummary-content": {
                alignItems: "center",
                margin: 0
            }
        } },
        React__default.createElement(AccordionSummary, { "aria-controls": "panel-content", id: "panel-header-accordion", sx: {
                margin: 0,
                padding: 0
            } },
            !isExpanded ? (React__default.createElement(KIcon, { fontSize: "small", className: "fa-solid fa-caret-right fa-xl", sx: {
                    marginRight: "10px"
                } })) : (React__default.createElement(KIcon, { fontSize: "small", className: "fa-caret-down fa-xl", sx: {
                    marginRight: "8px"
                } })),
            titleComponent),
        React__default.createElement(AccordionDetails, { sx: {
                padding: 0
            } }, children)));
};

export { SingleSimpleAccordion as default };
//# sourceMappingURL=index.js.map
